import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gamepad2, Flame, FileText, ImageIcon, ScrollText, Layers, ArrowUpRight, ExternalLink } from "lucide-react";
import { api } from "@/lib/api";
import { PageTitle, Card } from "@/admin/ui";

const STAT_META = [
  { key: "games", label: "Jogos", icon: Gamepad2 },
  { key: "hot", label: "Jogos HOT", icon: Flame },
  { key: "providers", label: "Provedoras", icon: Layers },
  { key: "prompts", label: "Prompts", icon: FileText },
  { key: "images", label: "Imagens", icon: ImageIcon },
  { key: "logs", label: "Ações (logs)", icon: ScrollText },
];

export const Dashboard = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <PageTitle
        title="Dashboard"
        subtitle="Visão geral do conteúdo do site Grupo Manga"
        action={
          <a
            href="/"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-white/[0.04] border border-white/10 text-sm text-white/80 hover:border-[#F5C542]/40 transition-colors"
          >
            <ExternalLink className="w-4 h-4" /> Ver Site
          </a>
        }
      />

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-8">
        {STAT_META.map((s) => (
          <Card key={s.key} className="!p-5">
            <s.icon className="w-5 h-5 text-[#F5C542] mb-3" />
            <div className="font-display text-3xl font-bold text-white tabular-nums">
              {stats ? stats[s.key] : "—"}
            </div>
            <div className="text-[11px] text-white/45 uppercase tracking-wider mt-1">{s.label}</div>
          </Card>
        ))}
      </div>

      <div className="grid lg:grid-cols-[1.5fr_1fr] gap-6">
        <Card>
          <h3 className="font-display font-bold text-white mb-4">Atividade Recente</h3>
          <div className="space-y-2">
            {stats?.recent_logs?.length ? (
              stats.recent_logs.map((l) => (
                <div key={l.id} className="flex items-center justify-between p-3 rounded-xl bg-white/[0.02] border border-white/[0.05]">
                  <div>
                    <span className="text-sm text-white font-medium">{l.action}</span>
                    <span className="text-white/40 text-xs ml-2">{l.detail}</span>
                  </div>
                  <span className="text-[11px] text-white/30">
                    {new Date(l.created_at).toLocaleString("pt-BR")}
                  </span>
                </div>
              ))
            ) : (
              <p className="text-white/40 text-sm">Sem atividades ainda.</p>
            )}
          </div>
        </Card>

        <Card>
          <h3 className="font-display font-bold text-white mb-4">Atalhos</h3>
          <div className="grid grid-cols-2 gap-3">
            {[
              { to: "/admin/jogos", label: "Gerenciar Jogos", icon: Gamepad2 },
              { to: "/admin/configuracoes", label: "Configurações", icon: Layers },
              { to: "/admin/imagens", label: "Imagens", icon: ImageIcon },
              { to: "/admin/prompts", label: "Prompts", icon: FileText },
            ].map((q) => (
              <Link
                key={q.to}
                to={q.to}
                className="group p-4 rounded-xl bg-white/[0.02] border border-white/[0.06] hover:border-[#F5C542]/40 transition-colors"
              >
                <q.icon className="w-5 h-5 text-[#F5C542] mb-2" />
                <div className="text-sm text-white/80 flex items-center gap-1">
                  {q.label}
                  <ArrowUpRight className="w-3.5 h-3.5 opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
              </Link>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
};
